var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIpCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H1.5C0.947715 0.5 0.5 0.947715 0.5 1.5V11C0.5 11.5523 0.947715 12 1.5 12H12.5C13.0523 12 13.5 11.5523 13.5 11V1.5C13.5 0.947715 13.0523 0.5 12.5 0.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8C9.4665 8 10.25 7.2165 10.25 6.25C10.25 5.2835 9.4665 4.5 8.5 4.5C7.5335 4.5 6.75 5.2835 6.75 6.25C6.75 7.2165 7.5335 8 8.5 8Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.25V4.5M8.5 8V9.25M11.5 6.25H10.25M6.75 6.25H5.5M10.62 4.12988L9.74 5.00988M7.26 7.48999L6.38 8.36999M10.62 8.36999L9.74 7.48999M7.26 5.00988L6.38 4.12988M3 4.5V8M2 12V13.5M11.5 12V13.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIpCategory);
export default __webpack_public_path__ + "static/media/sidebar-ip-category.88dddd531a4b5fe074f60a09b39e9fe0.svg";
export { ForwardRef as ReactComponent };